module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: ['color'],
    style: ({
      background: _vm.background,
      height: _vm.size + 'em',
      width: _vm.size + 'em'
    }),
    attrs: {
      "title": _vm.background
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15f02b73","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demo-components/color.vue
// module id = 44
// module chunks = 0